import { TLD_GLOBALLY } from '@/src/homepage/shared/constants/constants';
import { TOP_DESTINATIONS } from '@/src/homepage/shared/constants/topDestinations';
import { TLD } from '@/src/homepage/shared/types';

export function getTopDestinationsForTld(tld: TLD) {
    // This function retrieves around 15 top destinations based on tld
    // top destinations are determined by tlds
    const top_destinations = TOP_DESTINATIONS[tld] || TOP_DESTINATIONS[TLD_GLOBALLY];
    return top_destinations;
}
